import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "session_token";

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Safari/iOS blocks cross-site cookies; fall back to a Bearer token stored locally.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use((res) => {
  const t = res?.data?.session_token;
  if (t && typeof t === "string" && res.config?.url?.includes("/auth/")) localStorage.setItem(TOKEN_KEY, t);
  return res;
});

export const clearSessionToken = () => localStorage.removeItem(TOKEN_KEY);

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
